import { Button } from "artisn-ui-react";
import styled from "styled-components";

import { ButtonTotalStyledProps as Props } from "./ButtonTotal.types";

const ButtonTotalStyled = styled(Button)<Props>`
  padding: 1.6rem;
  margin-top: 1.2rem;
  margin-bottom: 2.4rem;
  background-color: var(--palette-primary);
  border-radius: 1rem;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  width: 100%;

  .ButtonTotal {
    &__wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__text {
      color: var(--palette-mid-blue-s15-l8);
      font-weight: 700;
      font-size: 1.6rem;
      text-align: left;
    }

    &__loading {
      justify-content: center;
    }
  }
`;

export default ButtonTotalStyled;
